import { useState } from 'react';
import { Button } from '../ui/Button';
import { cn } from '../../lib/cn';

type Props = {
  actions?: string[];
};

export function AIWritingStudio({ actions = [] }: Props) {
  const [selected, setSelected] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {actions.map((action) => (
          <button
            key={action}
            type="button"
            onClick={() => setSelected(action)}
            className={cn(
              'rounded-lg border px-3 py-1.5 text-xs font-medium transition',
              selected === action
                ? 'border-ai-400 bg-ai-100 text-ai-800 dark:border-ai-600 dark:bg-ai-950 dark:text-ai-300'
                : 'border-slate-200 text-slate-600 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-400',
            )}
          >
            {action}
          </button>
        ))}
      </div>
      {selected && (
        <div className="rounded-lg border border-ai-200 bg-ai-50/30 p-3 dark:border-ai-900 dark:bg-ai-950/20">
          <p className="text-xs text-ai-600">Action: {selected}</p>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            AI will apply Brand DNA, Product DNA, and governance rules to generate optimized content.
          </p>
          <Button
            variant="primary"
            size="sm"
            className="mt-2"
            disabled={busy}
            onClick={() => setBusy(true)}
          >
            Run {selected}
          </Button>
        </div>
      )}
    </div>
  );
}
